import * as _ from './socket-types.plugin';
import {isNullOrUndefined} from 'util';
import { IRootState } from '../root-state.store';
import { Store } from 'vuex';

export const createSocketPlugin = (socket) => {

  return (store: Store<IRootState | any>)  => {

    socket.on(_.SOCKET_EVENT_MESSAGE, (data) => {
      console.log("=============================")
      console.log("SOCKET_EVENT_MESSAGE:", data)
      console.log("=============================")
      store.commit(_.NOTIFICATION_INCREASE_UNREAD_MESSAGE, data.data)
      store.commit(_.TICKET_INCREASE_UNREAD_MESSAGE,data!.data!.ticket_id)
    })

    socket.on(_.SOCKET_EVENT_ATTACHMENT, (data) => {
      console.log("=============================")
      console.log("SOCKET_EVENT_MESSAGE:", data.data)
      console.log("=============================")

      store.commit(_.NOTIFICATION_INCREASE_UNREAD_MESSAGE, data.data)
      store.commit(_.TICKET_INCREASE_UNREAD_MESSAGE,data!.data!.ticket_id)
    })
    socket.on(_.SOCKET_EVENT_MESSAGE_EDIT, (data) => {
      console.log("=============================")
      console.log("SOCKET_EVENT_MESSAGE_EDIT:", data.data)
      console.log("=============================")
      store.commit(_.SOCKET_TICKET_EDIT_MESSAGE, {...data.data, ownerId: store.getters['user/userInfo'].id})
    })
    socket.on(_.SOCKET_EVENT_MESSAGE_DELETE, (data) => {
      console.log("=============================")
      console.log("SOCKET_EVENT_MESSAGE_DELETE:", data.data)
      console.log("=============================")
      store.commit(_.SOCKET_TICKET_DELETE_MESSAGE, {...data.data, ownerId: store.getters['user/userInfo'].id})
      store.commit(_.NOTIFICATION_DECREASE_UNREAD_MESSAGE, data.data)
    })
    socket.on(_.SOCKET_EVENT_ATTACHMENT_DELETE, (data) => {
      console.log("=============================")
      console.log("SOCKET_EVENT_ATTACHMENT_DELETE:", data.data)
      console.log("=============================")
      store.commit(_.SOCKET_TICKET_DELETE_MESSAGE, {...data.data, ownerId: store.getters['user/userInfo'].id})
      store.commit(_.NOTIFICATION_DECREASE_UNREAD_MESSAGE, data.data)
    })

    socket.on(_.SOCKET_EVENT_QUOTE_REQUEST, (data) => {
      console.log("=============================")
      console.log("SOCKET_EVENT_QUOTE_REQUEST:", data.data)
      console.log("=============================")
      store.commit(_.NOTIFICATION_INCREASE_UNREAD_MESSAGE, data.data)
      store.commit(_.TICKET_INCREASE_UNREAD_MESSAGE,data!.data!.ticket_id)
      const {actor} = data.data
      if (actor && actor.entity && actor.entity.id !== store.getters['user/userInfo'].id) {
        store.commit(_.SOCKET_TICKET_SET_TICKET_CHANNELS, data!.data!.ticket)
      }
    })
    socket.on(_.SOCKET_EVENT_MANDATE_REQUEST, (data) => {
      console.log("=============================")
      console.log("SOCKET_EVENT_MANDATE_REQUEST:", data.data)
      console.log("=============================")
      store.commit(_.SOCKET_TICKET_SET_TICKET_IN_LIST_REALTIME, data.data)
      store.commit(_.NOTIFICATION_INCREASE_UNREAD_MESSAGE, data.data)
      store.commit(_.TICKET_INCREASE_UNREAD_MESSAGE,data!.data!.ticket_id)
      const {actor} = data.data
      if (actor && actor.entity && actor.entity.id !== store.getters['user/userInfo'].id) {
        store.commit(_.SOCKET_TICKET_SET_TICKET_CHANNELS, data!.data!.ticket)
      }
    })

    socket.on(_.SOCKET_EVENT_ASK_APPOINTMENT, (data) => {
      console.log("=============================")
      console.log("SOCKET_EVENT_ASK_APPOINTMENT:", data.data)
      console.log("=============================")
      store.commit(_.NOTIFICATION_INCREASE_UNREAD_MESSAGE, data.data)
      store.commit(_.TICKET_INCREASE_UNREAD_MESSAGE,data!.data!.ticket_id)
    })

    socket.on(_.SOCKET_EVENT_CONFIRM_APPOINTMENT, (data) => {
      console.log("=============================")
      console.log("SOCKET_EVENT_CONFIRM_APPOINTMENT:", data.data)
      console.log("=============================")
      store.commit(_.SOCKET_TICKET_SET_TICKET_APPOINTMENT, {...data.data, ownerId: store.getters['user/userInfo'].id})
      store.commit(_.NOTIFICATION_INCREASE_UNREAD_MESSAGE, data.data)
      store.commit(_.TICKET_INCREASE_UNREAD_MESSAGE,data!.data!.ticket_id)
    })
    socket.on(_.SOCKET_EVENT_REJECT_APPOINTMENT, (data) => {
      console.log("=============================")
      console.log("SOCKET_EVENT_REJECT_APPOINTMENT:", data.data)
      console.log("=============================")
      store.commit(_.NOTIFICATION_INCREASE_UNREAD_MESSAGE, data.data)
      store.commit(_.TICKET_INCREASE_UNREAD_MESSAGE,data!.data!.ticket_id)
    })
    socket.on(_.SOCKET_EVENT_DONE_APPOINTMENT, (data) => {
      console.log("=============================")
      console.log("SOCKET_EVENT_DONE_APPOINTMENT:", data.data)
      console.log("=============================")
      store.commit(_.NOTIFICATION_INCREASE_UNREAD_MESSAGE, data.data)
      store.commit(_.TICKET_INCREASE_UNREAD_MESSAGE,data!.data!.ticket_id)
    })
    socket.on(_.SOCKET_EVENT_CANCEL_APPOINTMENT, (data) => {
      console.log("=============================")
      console.log("SOCKET_EVENT_CANCEL_APPOINTMENT:", data.data)
      console.log("=============================")
      store.commit(_.NOTIFICATION_INCREASE_UNREAD_MESSAGE, data.data)
      store.commit(_.TICKET_INCREASE_UNREAD_MESSAGE,data!.data!.ticket_id)
    })
    socket.on(_.SOCKET_EVENT_JOIN, (data) => {
      console.log("=============================")
      console.log("SOCKET_EVENT_JOIN:", data.data)
      console.log("=============================")
      store.commit(_.NOTIFICATION_INCREASE_UNREAD_MESSAGE, data.data)
      store.commit(_.SOCKET_TICKET_SET_TICKET_AFTER_JOIN, data.data)
      store.commit(_.TICKET_INCREASE_UNREAD_MESSAGE,data!.data!.ticket_id)
    })

    socket.on(_.SOCKET_EVENT_CLOSE, (data) => {
      console.log("=============================")
      console.log("SOCKET_EVENT_CLOSE:", data.data)
      console.log("=============================")
      store.commit(_.SOCKET_TICKET_SET_TICKET_STATE, data.data)
      store.commit(_.NOTIFICATION_INCREASE_UNREAD_MESSAGE, data.data)
      store.commit(_.TICKET_INCREASE_UNREAD_MESSAGE,data!.data!.ticket_id)
    })
    socket.on(_.SOCKET_EVENT_REOPEN, (data) => {
      console.log("=============================")
      console.log("SOCKET_EVENT_REOPEN:", data.data)
      console.log("=============================")

      if (isNullOrUndefined(data.data)) return;

      store.commit(_.SOCKET_TICKET_SET_TICKET_STATE, data.data)
      store.commit(_.NOTIFICATION_INCREASE_UNREAD_MESSAGE, data.data)
      store.commit(_.TICKET_INCREASE_UNREAD_MESSAGE,data!.data!.ticket_id)
    })
    socket.on(_.SOCKET_EVENT_OPEN, (data) => {
      console.log("=============================")
      console.log("SOCKET_EVENT_OPEN:", data.data)
      console.log("=============================")
      store.commit(_.NOTIFICATION_INCREASE_UNREAD_MESSAGE, data.data)
      store.commit(_.TICKET_INCREASE_UNREAD_MESSAGE,data!.data!.ticket_id)
      if (data.data.ticket_id) {
        store.dispatch(_.SOCKET_TICKET_GET_TICKET, data.data.ticket_id)
      }
    })

    /** DRIV-712: Handling real-time intervention report */
    socket.on(_.SOCKET_TICKET_INTERVENTION_REPORT, (data) => {
      console.log("=============================")
      console.log("SOCKET_TICKET_INTERVENTION_REPORT:", data.data)
      console.log("=============================")

      store.commit(_.NOTIFICATION_INCREASE_UNREAD_MESSAGE, data.data)
      store.commit(_.TICKET_INCREASE_UNREAD_MESSAGE,data!.data!.ticket_id)
    })

    socket.on(_.SOCKET_EVENT_NOTIFICATION_READ, (data) => {
      if (data.data) {
        store.commit(_.SOCKET_EVENT_NOTIFICATION_READ, data.data)
      }
    })
    socket.on(_.SOCKET_EVENT_NEW_GROUP, ({data}) => {
      const {entity} = data.actor;
      if (entity && entity.id !== store.getters['user/userInfo'].id) {
        store.dispatch(_.SOCKET_TICKET_GET_TICKET_CHANNEL, data)
        store.commit(_.NOTIFICATION_INCREASE_UNREAD_MESSAGE, data)
      }
    })

    socket.on(_.SOCKET_EVENT_JOIN_CHANNEL, (data) => {
      console.log("=============================")
      console.log("SOCKET_EVENT_JOIN_CHANNEL:", data.data)
      console.log("=============================")

      if (data.data) {
        const {actor} = data.data
        if (actor && actor.entity && actor.entity.id !== store.getters['user/userInfo'].id) {
          store.commit(_.NOTIFICATION_INCREASE_UNREAD_MESSAGE, data.data)
          store.commit(_.TICKET_INCREASE_UNREAD_MESSAGE,data!.data!.ticket_id)
        }
        store.commit(_.SOCKET_TICKET_JOIN_CHANNEL, data.data)
      }
    })

    socket.on(_.SOCKET_EVENT_QUIT_CHANNEL, (data) => {

      console.log("=============================")
      console.log("SOCKET_EVENT_QUIT_CHANNEL:", data.data)
      console.log("=============================")

      if (data.data) {
        const {actor} = data.data
        if (actor && actor.entity && actor.entity.id !== store.getters['user/userInfo'].id) {
          store.commit(_.NOTIFICATION_INCREASE_UNREAD_MESSAGE, data.data)
          store.commit(_.TICKET_INCREASE_UNREAD_MESSAGE,data!.data!.ticket_id)
        }
        store.commit(_.SOCKET_TICKET_QUIT_CHANNEL, data.data)
      }
    })

    socket.on(_.SOCKET_EVENT_REMOVE_IC, (data) => {

      console.log("=============================")
      console.log("SOCKET_EVENT_REMOVE_IC:", data.data)
      console.log("=============================")

      if (data.data) {
        store.commit(_.SOCKET_TICKET_REMOVE_IC, data.data)
      }
    })

    socket.on(_.SOCKET_EVENT_CLOSE_CHANNEL, (data) => {

      console.log("=============================")
      console.log("SOCKET_EVENT_CLOSE_CHANNEL:", data.data)
      console.log("=============================")

      if (data.data) {
        store.commit(_.SOCKET_TICKET_CLOSE_CHANNEL, data.data)
      }
    })

    socket.on(_.SOCKET_EVENT_REOPEN_CHANNEL, (data) => {

      console.log("=============================")
      console.log("SOCKET_EVENT_REOPEN_CHANNEL:", data.data)
      console.log("=============================")

      if (data.data) {
        const {actor} = data.data
        if (actor && actor.entity && actor.entity.id !== store.getters['user/userInfo'].id) {
          store.commit(_.TICKET_INCREASE_UNREAD_MESSAGE,data!.data!.ticket_id)
        }
        store.commit(_.SOCKET_TICKET_REOPEN_CHANNEL, data.data)
      }
    })

    socket.on(_.SOCKET_NEW_NOTIFICATION, (data) => {
      console.log("=============================")
      console.log("SOCKET_NEW_NOTIFICATION:", data)
      console.log("=============================")
      let fakeData = {fk_action_channel: -1}
      store.commit(_.NOTIFICATION_INCREASE_UNREAD_MESSAGE, fakeData)
    })

    socket.on(_.SOCKET_UPDATE_TICKET,data=>{
      const { data: { actor } } = data
      store.commit(_.SOCKET_TICKET_RECEIVE_MESSAGE, {...data.data, ownerId: actor.entity.id})
    })

    socket.on(_.SOCKET_NEW_TICKET_ACTION, data => {
      store.commit(_.SOCKET_TICKET_RECEIVE_MESSAGE, {...data.data, ownerId: store.getters['user/userInfo'].id})
    })

    /* entities CRUD  - BEGIN*/
    /* BLOCK - BEGIN */
    socket.on(_.SOCKET_ADD_BLOCK, d => {
      const { data } = d
      store.commit(_.SOCKET_BLOCK_EXTEND_LIST,data)
    })

    socket.on(_.SOCKET_UPDATE_BLOCK, d => {
      const { data: { address, name, id } } = d

      store.commit(_.SOCKET_BLOCK_UPDATE_BLOCK_DASHBOARD, {
        name,
        address
      })

      store.commit(_.SOCKET_BLOCK_UPDATE_LIST,{
          id,
          name,
          address
       })
    })

    socket.on(_.SOCKET_DELETE_BLOCK, d => {
      const { data: { id } } = d
      store.commit(_.SOCKET_BLOCK_SPLICE_LIST,id)
    })
    /* BLOCK - END */

    /* APARTMENT - BEGIN */
    socket.on(_.SOCKET_ADD_APARTMENT, d => {
      const { data } = d

      const apatment= {
        apartment: data.apartment,
        ...data.blockInfos
      }

      store.commit(_.SOCKET_APARTMENT_EXTEND_LIST,apatment)
      store.commit(_.SOCKET_APARTMENT_EXTEND_SIDEBAR_LIST,apatment)
      store.commit(_.SOCKET_APARTMENT_INCREMENT_COUNT)
    })

    socket.on(_.SOCKET_UPDATE_APARTMENT, d =>{
      console.log("apartment socket data",d)
      const { data: { apartment: { apartment_number, tenants, owners,  id } } } = d
      store.commit(_.SOCKET_APARTMENT_UPDATE_APARTMENT_DASHBOARD, { apartment_number, tenants, owners })
      store.commit(_.SOCKET_APARTMENT_UPDATE_LIST, {  id, apartment_number, tenants } )
      store.commit(_.SOCKET_APARTMENT_UPDATE_SIDEBAR_LIST,{ id, apartment_number })
    })

    socket.on(_.SOCKET_DELETE_APARTMENT, d=>{
      const {data: { apartment : { id } } } = d
      store.commit(_.SOCKET_APARTMENT_SPLICE_LIST,id)
      store.commit(_.SOCKET_APARTMENT_SPLICE_SIDEBAR_LIST,id)
      store.commit(_.SOCKET_APARTMENT_DECREMENT_COUNT)
    })
    /* APARTMENT - END */

    /* USER - BEGIN */
    socket.on(_.SOCKET_ADD_USER, d => {
      const { data: member } = d
      store.commit(_.SOCKET_MEMBERS_EXTEND_LIST,member)
    })

    socket.on(_.SOCKET_UPDATE_USER, d => {
      const { data: member } = d
      if(member.own){
        const { name, own, ...rest }= member
        store.commit(_.SOCKET_USER_UPDATE_DETAILS,rest)
        return
      }
      store.commit(_.SOCKET_MEMBERS_UPDATE_LIST,member)
    })

    socket.on(_.SOCKET_DELETE_USER, d => {
      const { data: { id } } = d
      store.commit(_.SOCKET_MEMBERS_SPLICE_LIST,id)
    })
    /* USER - END */
    /* entities CRUD - END */

    store.subscribe((mutation) => {
      if (mutation.type === 'user/USER_INFO_RECIEVED') {
        socket.emit('join', mutation.payload.id);
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/_plugin/root-plugin.store.ts